// Main-coverage options of an insurance provider, as configured in PCQM's
// insurance_provider_configuration (COVERAGE_MAIN / COVERAGE_MAIN_COMMERCIAL rows). The row value is
// JSON: `code` is what the calculate request sends as main coverage; `newValueRegulation`, when present,
// is fixed by the option and the nieuwwaarde dropdown is hidden.

export function parseCoverageOptions(rows, configurationType) {
  return (rows || [])
    .filter((row) => row.configurationType === configurationType && row.isActive !== false)
    .flatMap((row) => {
      try {
        const { code, newValueRegulation } = JSON.parse(row.configurationValue)
        return code ? [{ key: row.configurationKey, code, newValueRegulation }] : []
      } catch {
        return []
      }
    })
}

// Only for quotes calculated before PCQM stored the selected option key: pick the option that fits the
// stored coverage code and nieuwwaarde garantie best.
export function findCoverageOptionByCode(options, code, newValueRegulation) {
  const withCode = options.filter((x) => x.code === code)
  return withCode.find((x) => x.newValueRegulation === newValueRegulation) || withCode[0]
}
